module.exports = __webpack_public_path__ + "static/media/Bulk Upload Price Dealshub.a6202055.xlsx";